import {Component, OnInit} from '@angular/core';
import {ProductService} from '../../product-list/product-list.service';
import {FilterDataAttributes, FiltersAttributes, filterTypesAttributes} from '../../product-list/product';
import {Config} from '../../services/env.config';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {

  constructor(private route: ActivatedRoute,) {
    // this.sidenavUrl = this.router.url;
  }
  ngOnInit() {
   
  }
}
